import nigeria from '../../assets/img/country_flags/nigeria.svg';
import dominican from '../../assets/img/country_flags/dominican_republic.svg';
import costa_rica from '../../assets/img/country_flags/costa_rica.svg';
import colombia from '../../assets/img/country_flags/colombia.svg';
import brazil from '../../assets/img/country_flags/brazil.svg';
import egypt from '../../assets/img/country_flags/egypt.svg';
import ghana from '../../assets/img/country_flags/ghana.svg';
import bangladesh from '../../assets/img/country_flags/bangladesh.svg';
import india from '../../assets/img/country_flags/india.svg';
import turkey from '../../assets/img/country_flags/turkey.svg';
import kenya from '../../assets/img/country_flags/kenya.svg';
import ukraine from '../../assets/img/country_flags/ukraine.svg';
import serbia from '../../assets/img/country_flags/serbia.svg';
import pakistan from '../../assets/img/country_flags/pakistan.svg';
import palestine from '../../assets/img/country_flags/palestine.svg';

const testimonials = [
  {
    country: 'Dominican Republic',
    developers: [
      // {
      //   name: 'Samuel',
      //   quote: 'Every day, I feel more productive and excited to work',
      //   url: '',
      //   country: 'Dominican Republic'
      // },
      // {
      //   name: 'Yumarx',
      //   quote: 'Turing offered me good compensation compared to local salaries, in addition to long-term opportunity, flexibility, and ownership.',
      //   url: '',
      //   country: 'Dominican Republic'
      // }
    ]
  },
  {
    country: 'Costa Rica',
    developers: [
      {
        name: 'Alexander',
        quote: 'I started working remotely a few years ago and I don’t think I’ll go back to an office ever again!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Alexandar.jpg',
        country: 'Costa Rica',
        role: 'Full-Stack Developer'
      },
      // {
      //   name: 'Pedro',
      //   quote: 'With Turing’s commission-free payments and the flexibility to work from anywhere, I can now make my dream of traveling the world come true.',
      //   country: 'Brazil'
      // },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      // {
      //   name: 'Samuel',
      //   quote: 'Every day, I feel more productive and excited to work',
      //   country: 'Dominican Republic'
      // },
      {
        name: 'Hernan',
        quote: 'Working with Turing has impacted my overall growth and I especially appreciate the fact that all my payments come on time!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Hernan.jpg',
        country: 'Colombia'
      },
      {
        name: 'Juan',
        quote: 'The entire process was very efficient and definitely faster than other job boards.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Juan.jpg',
        country: 'Colombia'
      }
    ]
  },
  {
    country: 'Colombia',
    developers: [
      {
        name: 'Hernan',
        quote: 'Working with Turing has impacted my overall growth and I especially appreciate the fact that all my payments come on time!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Hernan.jpg',
        country: 'Colombia'
      },
      {
        name: 'Juan',
        quote: 'The entire process was very efficient and definitely faster than other job boards.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Juan.jpg',
        country: 'Colombia'
      },
      {
        name: 'Andres',
        quote: 'Turing has helped me live a more rounded and complete life. I now have full control of my time and my day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Andres.jpg',
        country: 'Colombia'
      },
      {
        name: 'Sergio',
        quote: 'After I cleared the challenging Tests, I was hired by a great U.S. firm, within a week.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sergio.jpg',
        country: 'Colombia'
      },
      // {
      //   name: 'Pedro',
      //   quote: 'With Turing’s commission-free payments and the flexibility to work from anywhere, I can now make my dream of traveling the world come true.',
      //   country: 'Brazil'
      // },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      }
    ]
  },
  {
    country: 'Brazil',
    developers: [
      // {
      //   name: 'Pedro',
      //   quote: 'With Turing’s commission-free payments and the flexibility to work from anywhere, I can now make my dream of traveling the world come true.',
      //   country: 'Brazil'
      // },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Andre',
        quote: 'Turing’s Intelligent talent cloud has not only helped me find reliable long-term jobs with great pay, but also the freedom to work at my own pace.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Andre.jpg',
        country: 'Brazil'
      },
      {
        name: 'Luis',
        quote: 'I’m building software that helps the world move towards a sustainable future from the comforts of my couch.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Luis.jpg',
        country: 'Brazil'
      },
      {
        name: 'Leonam',
        quote: 'Thanks to Turing and its remote-first culture, I’m available physically and emotionally for my wife and child.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Leonam.jpg',
        country: 'Brazil'
      },
      {
        name: 'Franco',
        quote: 'I’ve been living in Sao Paolo and working from the most comfortable, luxurious, and cozy place in the world, my home!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Franco.jpg',
        country: 'Brazil'
      }
    ]
  },
  {
    country: 'Egypt',
    developers: [
      {
        name: 'Mohamed',
        quote: 'Working at a place where quantity mattered over quality was very frustrating. Turing brought a radical shift in my life and I have never been this happier and satisfied.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mohamad.jpg',
        country: 'Egypt'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // },
      {
        name: 'Shadrack',
        quote: 'With Turing, I get to work with world-class engineers and learn something new every day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Shad.jpg',
        country: 'Kenya'
      },
      {
        name: 'Olu',
        quote: 'I told Turing exactly what I wanted in my career going forward, how much compensation I needed, and they delivered on both!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Olu.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Chibuike',
        quote: 'Once I got matched with a top U.S company, I knew I was free of the job hunting race forever, since Turing has made it super easy for me to move jobs.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Chibuike.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Somoye',
        quote: 'For the first time, I can say that I enjoy my place of work a lot. My work adapts to my schedule, and not the other way round',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Somoye.jpg',
        country: 'Nigeria'
      }
    ]
  },
  {
    country: 'Ghana',
    developers: [
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // },
      {
        name: 'Mohamed',
        quote: 'Working at a place where quantity mattered over quality was very frustrating. Turing brought a radical shift in my life and I have never been this happier and satisfied.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mohamad.jpg',
        country: 'Egypt'
      },
      {
        name: 'Shadrack',
        quote: 'With Turing, I get to work with world-class engineers and learn something new every day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Shad.jpg',
        country: 'Kenya'
      },
      {
        name: 'Olu',
        quote: 'I told Turing exactly what I wanted in my career going forward, how much compensation I needed, and they delivered on both!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Olu.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Chibuike',
        quote: 'Once I got matched with a top U.S company, I knew I was free of the job hunting race forever, since Turing has made it super easy for me to move jobs.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Chibuike.jpg',
        country: 'Nigeria'
      }
    ]
  },
  {
    country: 'Nigeria',
    developers: [
      {
        name: 'Olu',
        quote: 'I told Turing exactly what I wanted in my career going forward, how much compensation I needed, and they delivered on both!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Olu.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Chibuike',
        quote: 'Once I got matched with a top U.S company, I knew I was free of the job hunting race forever, since Turing has made it super easy for me to move jobs.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Chibuike.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Somoye',
        quote: 'For the first time, I can say that I enjoy my place of work a lot. My work adapts to my schedule, and not the other way round',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Somoye.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Egbe',
        quote: "Once you get vetted, Turing's AI-assisted matching engine will match you with better and better jobs, one after the next.",
        uel: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Egbe.jpg',
        country: 'Nigeria'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // },
      {
        name: 'Shadrack',
        quote: 'With Turing, I get to work with world-class engineers and learn something new every day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Shad.jpg',
        country: 'Kenya'
      }
    ]
  },
  {
    country: 'Bangladesh',
    developers: [
      {
        name: 'Sakib',
        quote: 'Because of Turing, I was able to move back to my hometown with my wife, without abandoning my career growth or sacrificing a great pay.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sakib.jpg',
        country: 'Bangladesh'
      },
      {
        name: 'Al-Mamun',
        quote: 'Since joining Turing, I feel fantastic about showing up every day in a great environment with brilliant colleagues.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mamun.jpg',
        country: 'Bangladesh'
      },
      {
        name: 'Harsh',
        quote: "Turing is different from other remote 'gig' websites and it actually offers you long-term jobs!",
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Harsh.jpg',
        country: 'India'
      },
      {
        name: 'Vinay',
        quote: 'The test is designed to gauge your efficiency on things that you’d actually come across while working for top US companies.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/vinay.jpg',
        country: 'India'
      },
      {
        name: 'Zeeshan',
        quote: 'The most attractive thing about Turing for me was its reliability in terms of matches. The quality of jobs that Turing offers is amazing',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Zeeshan.jpg',
        country: 'Pakistan',
        role: 'Full-Stack Engineer'
      },
      {
        name: 'Numan',
        quote: 'As a Turing talent, I am always compensated healthily because of commission-free payments. The salary withdrawal process is smooth and seamless.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Numan.jpg',
        country: 'Pakistan'
      }
    ]
  },
  {
    country: 'India',
    developers: [
      {
        name: 'Harsh',
        quote: "Turing is different from other remote 'gig' websites and it actually offers you long-term jobs!",
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Harsh.jpg',
        country: 'India'
      },
      {
        name: 'Vinay',
        quote: 'The test is designed to gauge your efficiency on things that you’d actually come across while working for top US companies.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/vinay.jpg',
        country: 'India'
      },
      {
        name: 'Sidhartha',
        quote: 'I get to see and shape my daughter’s formative years that most people miss out during work. That too while securing her future financially',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sidhartha.jpg',
        country: 'India'
      },
      {
        name: 'Arnab',
        quote: 'With Turing, I achieved two great things at the same time- remote work flexibility and long-term opportunity.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Arnab.jpg',
        country: 'India'
      },
      {
        name: 'Dharmendra',
        quote: 'It’s only because of remote jobs that I can interact with engineers from around the world and learn things I might’ve never been able to learn working traditionally.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Dharmendra.jpg',
        country: 'India'
      },
      {
        name: 'Al-Mamun',
        quote: 'Since joining Turing, I feel fantastic about showing up every day in a great environment with brilliant colleagues.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mamun.jpg',
        country: 'Bangladesh'
      }
    ]
  },
  {
    country: 'Turkey',
    developers: [
      {
        name: 'Gultekin',
        quote: 'Before Turing, I never experienced the essence of work-life balance. Now that I am working remotely I have plenty of time to spend with my family.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Gultkein.jpg',
        country: 'Turkey',
        role: 'ML Engineer'
      },
      {
        name: 'Damjan',
        quote: 'Now, I work with a fast scaling health technology company based in the US. It’s really nice to see that the code you write can make an impact on someone’s life.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Damjan.jpg',
        country: 'Serbia',
        role: 'Full Stack Developer'
      },
      {
        name: 'Randa',
        quote: 'The Turing Community has given me a unique experience and connected me with like-minded people across the world. It’s superb!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Randa.jpg',
        country: 'Palestine'
      },
      {
        name: 'Mohamed',
        quote: 'Working at a place where quantity mattered over quality was very frustrating. Turing brought a radical shift in my life and I have never been this happier and satisfied.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mohamad.jpg',
        country: 'Egypt'
      },
      {
        name: 'Zeeshan',
        quote: 'The most attractive thing about Turing for me was its reliability in terms of matches. The quality of jobs that Turing offers is amazing',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Zeeshan.jpg',
        country: 'Pakistan',
        role: 'Full-Stack Engineer'
      },
      {
        name: 'Numan',
        quote: 'As a Turing talent, I am always compensated healthily because of commission-free payments. The salary withdrawal process is smooth and seamless.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Numan.jpg',
        country: 'Pakistan'
      }
    ]
  },
  {
    country: 'Kenya',
    developers: [
      {
        name: 'Shadrack',
        quote: 'With Turing, I get to work with world-class engineers and learn something new every day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Shad.jpg',
        country: 'Kenya'
      },
      {
        name: 'Olu',
        quote: 'I told Turing exactly what I wanted in my career going forward, how much compensation I needed, and they delivered on both!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Olu.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Chibuike',
        quote: 'Once I got matched with a top U.S company, I knew I was free of the job hunting race forever, since Turing has made it super easy for me to move jobs.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Chibuike.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Somoye',
        quote: 'For the first time, I can say that I enjoy my place of work a lot. My work adapts to my schedule, and not the other way round',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Somoye.jpg',
        country: 'Nigeria'
      },
      {
        name: 'Egbe',
        quote: "Once you get vetted, Turing's AI-assisted matching engine will match you with better and better jobs, one after the next.",
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Egbe.jpg',
        country: 'Nigeria'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // }
    ]
  },
  {
    country: 'Ukraine',
    developers: [
      {
        name: 'Sergii',
        quote: 'I now have rented an office space to work whenever I don’t feel like sitting at home. I also own an indoor beach volleyball gym which is Ukraine’s first by the way.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sergii.jpg',
        country: 'Ukraine'
      },
      {
        name: 'Dennis',
        quote: 'The Turing hiring process felt very optimized to me. I was tested on my technical and communication skills. It was a very pleasant experience overall.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Dennis.jpg',
        country: 'Ukraine'
      },
      {
        name: 'Damjan',
        quote: 'Now, I work with a fast scaling health technology company based in the US. It’s really nice to see that the code you write can make an impact on someone’s life.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Damjan.jpg',
        country: 'Serbia',
        role: 'Full Stack Developer'
      },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Alexander',
        quote: 'I started working remotely a few years ago and I don’t think I’ll go back to an office ever again!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Alexandar.jpg',
        country: 'Costa Rica',
        role: 'Full-Stack Developer'
      },
      {
        name: 'Hernan',
        quote: 'Working with Turing has impacted my overall growth and I especially appreciate the fact that all my payments come on time!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Hernan.jpg',
        country: 'Colombia'
      }
    ]
  },
  {
    country: 'Serbia',
    developers: [
      {
        name: 'Damjan',
        quote: 'Now, I work with a fast scaling health technology company based in the US. It’s really nice to see that the code you write can make an impact on someone’s life.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Damjan.jpg',
        country: 'Serbia',
        role: 'Full Stack Developer'
      },
      {
        name: 'Sergii',
        quote: 'I now have rented an office space to work whenever I don’t feel like sitting at home. I also own an indoor beach volleyball gym which is Ukraine’s first by the way.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sergii.jpg',
        country: 'Ukraine'
      },
      {
        name: 'Dennis',
        quote: 'The Turing hiring process felt very optimized to me. I was tested on my technical and communication skills. It was a very pleasant experience overall.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Dennis.jpg',
        country: 'Ukraine'
      },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Alexander',
        quote: 'I started working remotely a few years ago and I don’t think I’ll go back to an office ever again!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Alexandar.jpg',
        country: 'Costa Rica',
        role: 'Full-Stack Developer'
      },
      {
        name: 'Hernan',
        quote: 'Working with Turing has impacted my overall growth and I especially appreciate the fact that all my payments come on time!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Hernan.jpg',
        country: 'Colombia'
      }
    ]
  },
  {
    country: 'Pakistan',
    developers: [
      {
        name: 'Zeeshan',
        quote: 'The most attractive thing about Turing for me was its reliability in terms of matches. The quality of jobs that Turing offers is amazing',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Zeeshan.jpg',
        country: 'Pakistan',
        role: 'Full-Stack Engineer'
      },
      {
        name: 'Numan',
        quote: 'As a Turing talent, I am always compensated healthily because of commission-free payments. The salary withdrawal process is smooth and seamless.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Numan.jpg',
        country: 'Pakistan'
      },
      {
        name: 'Sakib',
        quote: 'Because of Turing, I was able to move back to my hometown with my wife, without abandoning my career growth or sacrificing a great pay.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Sakib.jpg',
        country: 'Bangladesh'
      },
      {
        name: 'Al-Mamun',
        quote: 'Since joining Turing, I feel fantastic about showing up every day in a great environment with brilliant colleagues.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mamun.jpg',
        country: 'Bangladesh'
      },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Alexander',
        quote: 'I started working remotely a few years ago and I don’t think I’ll go back to an office ever again!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Alexandar.jpg',
        country: 'Costa Rica',
        role: 'Full-Stack Developer'
      }
    ]
  },
  {
    country: 'Palestine',
    developers: [
      {
        name: 'Randa',
        quote: 'The Turing Community has given me a unique experience and connected me with like-minded people across the world. It’s superb!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Randa.jpg',
        country: 'Palestine'
      },
      {
        name: 'Mohamed',
        quote: 'Working at a place where quantity mattered over quality was very frustrating. Turing brought a radical shift in my life and I have never been this happier and satisfied.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Mohamad.jpg',
        country: 'Egypt'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // },
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Alexander',
        quote: 'I started working remotely a few years ago and I don’t think I’ll go back to an office ever again!',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Alexandar.jpg',
        country: 'Costa Rica',
        role: 'Full-Stack Developer'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // }
    ]
  },
  {
    country: 'Default',
    developers: [
      {
        name: 'Vini',
        quote: 'Turing seemed like the best place for me since it gave me the opportunity to grow my career significantly faster while working remotely.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Vini.jpg',
        country: 'Brazil'
      },
      {
        name: 'Juan',
        quote: 'The entire process was very efficient and definitely faster than other job boards.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Juan.jpg',
        country: 'Colombia'
      },
      {
        name: 'Arnab',
        quote: 'With Turing, I achieved two great things at the same time- remote work flexibility and long-term opportunity.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Arnab.jpg',
        country: 'India'
      },
      {
        name: 'Gultekin',
        quote: 'Before Turing, I never experienced the essence of work-life balance. Now that I am working remotely I have plenty of time to spend with my family.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Gultkein.jpg',
        country: 'Turkey',
        role: 'ML Engineer'
      },
      // {
      //   name: 'Tsatsu',
      //   quote: 'Turing promised personalized career mentoring with lifelong matching to high-quality, remote US jobs, and I was instantly hooked.',
      //   country: 'Ghana'
      // },
      {
        name: 'Shadrack',
        quote: 'With Turing, I get to work with world-class engineers and learn something new every day.',
        url: 'https://storage.googleapis.com/turing-developers-images/social-proof-optimised/Shad.jpg',
        country: 'Kenya'
      }
    ]
  }
];
export const countryFlags = {
  'dominican republic': dominican,
  'costa rica': costa_rica,
  'colombia': colombia,
  'brazil': brazil,
  'egypt': egypt,
  'ghana': ghana,
  'nigeria': nigeria,
  'bangladesh': bangladesh,
  'india': india,
  'turkey': turkey,
  'kenya': kenya,
  'ukraine': ukraine,
  'serbia': serbia,
  'pakistan': pakistan,
  'palestine': palestine
}
export default testimonials;
